"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEmotionCache = createEmotionCache;
var _cache = _interopRequireDefault(require("@emotion/cache"));
/** @deprecated Use the `createCache` function from the `@emotion/cache` library. Will be removed in the next major release. */
function createEmotionCache(key = 'appshell-ms') {
  // `prepend: true` moves MUI styles to the top of the <head> so they're loaded first. It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
  return {
    key,
    cache: (0, _cache.default)({
      key,
      prepend: true
    })
  };
}
